module.exports = __webpack_public_path__ + "img/border_one.e6551f61.png";